import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <h3 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight">
              Let's help you reduce costs<br />
              and grow your business<span className="text-[#FF5A1F]">.</span>
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3 text-base font-semibold text-[#0a0a0a] bg-white hover:bg-[#FF5A1F] hover:text-white rounded-full transition-all duration-200"
            >
              Start the conversation <ArrowUpRight size={18} />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#FF5A1F] mb-5">Contact</p>
            <a
              href="mailto:info@fencodigital.com"
              className="flex items-start gap-3 text-gray-200 hover:text-white transition mb-3"
              data-testid="footer-email-link"
            >
              <Mail size={18} className="mt-1 text-[#FF5A1F]" />
              <span className="font-medium">info@fencodigital.com</span>
            </a>
            <a
              href="tel:07426821449"
              className="flex items-start gap-3 text-gray-200 hover:text-white transition"
              data-testid="footer-phone-link"
            >
              <Phone size={18} className="mt-1 text-[#FF5A1F]" />
              <span className="font-medium">07426 821449</span>
            </a>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#FF5A1F] mb-5">Solutions</p>
            <ul className="space-y-3">
              <li>
                <Link to="/card-payments" className="text-gray-300 hover:text-white" data-testid="footer-link-payments">
                  Card Payments
                </Link>
              </li>
              <li>
                <Link to="/pos-systems" className="text-gray-300 hover:text-white" data-testid="footer-link-pos">
                  POS Systems
                </Link>
              </li>
              <li>
                <Link to="/website-design" className="text-gray-300 hover:text-white" data-testid="footer-link-website">
                  Website Design
                </Link>
              </li>
              <li>
                <Link to="/app-design" className="text-gray-300 hover:text-white" data-testid="footer-link-app">
                  App Design
                </Link>
              </li>
              <li>
                <Link to="/get-started" className="text-gray-300 hover:text-white" data-testid="footer-link-getstarted">
                  Get a Quote
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#FF5A1F] mb-5">Company</p>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-300 hover:text-white" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-white" data-testid="footer-link-faq">FAQ</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="bg-white rounded-xl p-2 inline-flex items-center">
            <img
              src="/brand/fenco-logo.png"
              alt="Fenco Digital"
              className="h-12 w-auto"
            />
          </div>
          <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-6">
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("fenco:open-cookie-banner"))}
              data-testid="footer-manage-cookies"
              className="text-sm text-gray-400 hover:text-white transition text-left"
            >
              Manage cookies
            </button>
            <Link to="/privacy" className="text-sm text-gray-400 hover:text-white transition" data-testid="footer-link-privacy">
              Privacy Policy
            </Link>
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} Fenco Digital. Smart solutions. Real results.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
